import { Map, Record, Set } from "immutable";

import createFromJS from "../../../createFromJS";
import { SyncRepresentationRecord } from "../../sync/SyncRepresentationRecord";
import { SyncStatusRecord } from "../../sync/SyncStatusRecord";
import { SyncSettingsRecord } from "./SyncSettingsRecord";

export const TimelineSyncRecord = Record({
  settings: new SyncSettingsRecord(),
  lastSyncRep: new SyncRepresentationRecord(),
  externalRep: null,
  fileMissing: false,
  isScrivener2: false,
  status: new SyncStatusRecord(),
  localToExternalIds: Map(),
  customFieldsIdsMap: Map(),
  userActions: Map(),
  userCreatedLinks: Map(),
  ignoreExternalIds: Set()
});

const data = {
  objects: {
    settings: "SyncSettingsRecord",
    lastSyncRep: "SyncRepresentationRecord",
    externalRep: "SyncRepresentationRecord",
    status: "SyncStatusRecord",
    localToExternalIds: "Map",
    userCreatedLinks: "Map",
    ignoreExternalIds: "Set"
  },
  collections: {
    userActions: "SyncUpdatePropertyRecord",
    customFieldsIdsMap: "Map" // this is a Map of Maps of strings
  }
};
createFromJS.registerCallback("TimelineSyncRecord", createFromJS.createNestedCallback(TimelineSyncRecord, data));
